import Vue from 'vue';

export default {
  items: [
    {
      name: Vue.prototype.$tk('nav.administration_nav_title'),
      url: '/administration',
      icon: 'icon-settings',
      permissions: ['activities.view'], // Todo : replace with more precise permission
      disableOffline: true,
      children: [
        {
          name: Vue.prototype.$tk('nav.users_list_title'),
          url: '/administration/users',
          permissions: ['users.view'],
          disableOffline: true,
        },
        {
          name: Vue.prototype.$tk('nav.roles_list_title'),
          url: '/administration/roles',
          permissions: ['roles.view'],
          disableOffline: true,
        },
        {
          name: Vue.prototype.$tk('nav.audit_logs_list_title'),
          url: '/administration/audit-logs',
          permissions: ['activities.view'],
          disableOffline: true,
        },
        {
          name: Vue.prototype.$tk('nav.languages_list_title'),
          url: '/administration/languages',
          permissions: ['languages.view'],
          disableOffline: true,
        },
        {
          name: Vue.prototype.$tk('nav.translations_list_title'),
          url: '/administration/translations',
          permissions: ['translations.view'],
          disableOffline: true,
        },
      ]
    },
    {
      name: Vue.prototype.$tk('nav.dashboard_nav_title'),
      url: '/dashboard',
    },
    {
      name: Vue.prototype.$tk('nav.pdf_generator_list_title'),
      url: '/pdf_generator',
      permissions: ['pdf_generator.view'],
    },
    {
      name: Vue.prototype.$tk('nav.qr_scanner_list_title'),
      url: '/qr_scanner',
      permissions: ['qr_scanners.view'],
    },
    // GenCrud.0.stubpart (stub fragment will be generated bellow this line - do not delete this)
    {
      name: Vue.prototype.$tk('nav.resources_list_title'),
      url: '/resources',
      permissions: ['resources.view'],
    },
    {
      name: Vue.prototype.$tk('nav.unique_ids_list_title'),
      url: '/unique_ids',
      permissions: ['unique_ids.view'],
    },
  ]
};
